__turbopack_context__.v({
  "wizardStepButtonList": "_8-HJKG_wizardStepButtonList",
  "wizardStepSimpleList": "_8-HJKG_wizardStepSimpleList",
});
